import { HtmlDiv } from 'htmlmodule'
import './AlbumCardTitle.css'

export class AlbumCardTitle extends HtmlDiv
{
  static class = 'AlbumCardTitle'
}
